import React from 'react';
import { PaymentSetupGuide } from '../components/PaymentSetupGuide';

const PaymentSetup = () => {
  return <PaymentSetupGuide />;
};

export default PaymentSetup;